import InputWrapper from "../../../../../../components/input/wrapper/InputWrapper";
import Select from "../../../../../../components/select/main/Select";
import { useLanguageContext } from "../../../../../../context/LanguageContext";
import EVAApiHelper from "../../../../../../helpers/EVAApiHelper";
import { StyledFlexColumn } from "../../../../../../styles/LayoutStyles";
import PositionForm from "../default/position/PositionForm";
import SizeForm from "../default/size/SizeForm";

function ImageFormView({
  setPrinterData,
  selectedLabelItem,
  selectedLabelItemIndex,
  images,
  onImageChange,
  submitError,
}) {
  const { translate } = useLanguageContext();

  return (
    <StyledFlexColumn>
      {/* Position */}
      <PositionForm
        setPrinterData={setPrinterData}
        selectedLabelItem={selectedLabelItem}
        selectedLabelItemIndex={selectedLabelItemIndex}
        submitError={submitError}
      />

      {/* Size */}
      <SizeForm
        setPrinterData={setPrinterData}
        selectedLabelItem={selectedLabelItem}
        selectedLabelItemIndex={selectedLabelItemIndex}
        submitError={submitError}
      />

      <InputWrapper
        label={translate(
          "eva.main.validation.attributes.label_items.*.image_id"
        )}
        required
        error={EVAApiHelper.getResponseError(
          `label_items.${selectedLabelItemIndex}.image_id`,
          submitError
        )}
      >
        <Select
          options={images.map((image) => ({
            value: image.id,
            label: image.name,
          }))}
          value={selectedLabelItem.image_id}
          onChange={onImageChange}
        />
      </InputWrapper>
    </StyledFlexColumn>
  );
}

export default ImageFormView;
